/**
 * Dashboard stats (admin only)
 */

import { apiClient } from '../client'

export interface DashboardScheduleItem {
  title: string
  subtitle: string
  timeLabel: string
  variant: 'blue' | 'orange' | 'purple'
}

export interface DashboardStats {
  jobs: {
    total: number
    open: number
    closed: number
    approved?: number
    pendingApproval?: number
    rejected?: number
  }
  applications: Record<string, number>
  recentApplications: Array<{
    id: number
    job_id: number
    job_title: string | null
    user_id: number
    applicant_name: string | null
    applicant_email: string | null
    applicant_phone: string | null
    applicant_avatar_path?: string | null
    applied_at: string
    status: string
  }>
  questionnaire: {
    questions: { total: number; active: number; inactive: number }
    answersTotal: number
    /** Distinct users with every stored answer row filled (non-empty). */
    solvedUserCount?: number
  }
  users?: { total: number; admins: number; candidates: number }
  charts?: {
    applicationTrends: { labels: string[]; applications: number[]; hires: number[] }
    jobsByDepartment: { department: string; open: number; closed: number }[]
  }
  schedule?: DashboardScheduleItem[]
  deltas?: {
    applicationsWeekPercent: number
  }
}

export const dashboardRepository = {
  async getStats(): Promise<DashboardStats> {
    const res = await apiClient.get<DashboardStats>('/dashboard/stats')
    return res
  },
}
